import {Card, Col, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import React, {SetStateAction, useEffect, useState} from "react";
import {IBrand} from "../interface";
import {PICTURE_URL} from "../../../helpers/api.routes";
import {AdminBrandCategoryService} from "../../brandCategory/service";
import {ErrorToast} from "../../../shared/toasters/toasters";
import {IBrandCategory} from "../../brandCategory/interface";
import Select, {GroupBase} from "react-select";

interface IProps {
    state: IBrand | null;
    setState: React.Dispatch<SetStateAction<IBrand | null>>;
    setImage: React.Dispatch<SetStateAction<File | null>>;
    setIsMenuOpened: React.Dispatch<React.SetStateAction<boolean>>;
}


export const CreateForm = ({state, setState, setImage, setIsMenuOpened,}: IProps) => {
    const {t} = useTranslation();
    const [categories, setCategories] = useState<GroupBase<IBrandCategory>[]>([]);
    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setState((prev: any) => ({...prev, [name]: value}));
    };
    const fileHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.files && setImage(e.target.files[0]);
    };
    const switchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState((prev) => ({...prev, [e.target.name]: e.target.checked}) as IBrand);
    };
    const selectHandler = (e: { value: number, }) => {
        setState((prev: any) => ({...prev, category: e?.value}));
    };
    useEffect(() => {
        AdminBrandCategoryService.getAll({page: 1, perPage: 0})
            .then((response) => {
                const {data} = response;
                setCategories((data?.items)?.map((category: IBrandCategory) => ({
                    label: category?.title,
                    value: category?.id,
                })));
            })
            .catch(ErrorToast)
    }, []);
    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col md={4}>
                        <label htmlFor="name" className="required-field">
                            {t("global.name")}
                        </label>
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            required
                            onChange={changeHandler}
                            value={state?.id && state?.name}
                        />
                    </Col>
                    <Col md={4}>
                        <label htmlFor="name" className="required-field">
                            {t("global.link")}
                        </label>
                        <input
                            type="text"
                            name="link"
                            className="form-control"
                            required
                            onChange={changeHandler}
                            value={state?.id && state?.link}
                        />
                    </Col>
                    <Col md={2}>
                        <div className="form-check form-switch p-0">
                            <label
                                className="d-block text-start"
                                htmlFor="activeSwitch"
                            >
                                {t("global.active")}
                            </label>
                            <div className="row">
                                <input
                                    className="form-check-input switch-custom ms-4 mt-2"
                                    type="checkbox"
                                    name={"active"}
                                    checked={state?.active}
                                    onChange={switchHandler}
                                    role="switch"
                                    id="activeSwitch"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={4} className="mt-1">
                        <label htmlFor="category" className="required-field">
                            {t("global.category")}
                        </label>
                        <Select
                            id="category"
                            className="react-select-field"
                            onChange={(e) => selectHandler(e as unknown as { value: number })}
                            value={categories?.find((category) => (category as unknown as { value: number })?.value === ((state?.category as IBrandCategory)?.id || state?.category))}
                            options={categories}
                        />
                    </Col>
                    <div className="mt-3">
                        <label htmlFor="imageFile"> {t("download.image")}</label>
                        <input
                            onChange={fileHandler}
                            className="form-control"
                            type="file"
                            accept="image/*"
                            id="imageFile"
                        />
                    </div>
                    {state?.image && (
                        <div className="d-flex align-items-center mt-3">
                            <img
                                className="object-fit-cover"
                                width={200}
                                height={200}
                                src={PICTURE_URL + state?.image.path}
                                data-holder-rendered="true"
                                alt={state?.image?.name}
                                style={{margin: '2px'}}
                            />
                        </div>
                    )}
                </Row>
                <div className="col-12 my-2 d-flex justify-content-end text-align-center">
                    <div>
                        <button
                            className="btn btn-info"
                            type={'button'}
                            onClick={() => {
                                setIsMenuOpened(false);
                                setState(null);
                            }}
                        >
                            {t("global.cancel")}
                        </button>
                        <button className="btn btn-primary ms-3" type="submit">
                            {state?.id ? `  ${t("global.update")}` : `${t("global.create")}`}
                        </button>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};
